export const UpdateDeliveryProviderFetchProjection = [
    "name",
    "deliveryProviderId",
    "contactName",
    "phone",
    "deliverySystem",
    "email",
    "paymentTerms",
    "dealerType",
    "homeDeliveryPrice",
    "deliveryPricingSetting",
    "availability",
    "businessCertificate",
    "idNumber",
    "licenseNumber"
];
